module.exports = __webpack_public_path__ + "img/advantage5.c1ff1ab8.svg";